import {ICreateTestTrainingConfig} from "./_interfaces";
import ClassroomsSelect from "../formFields/ClassroomsSelect";
import CreateTestSelectedClassrooms from "../formFields/CreateTestSelectedClassrooms";
import CreateTestConfiguration from "../formFields/TestConfiguration";
import TagSelect from "../formFields/TagSelect";
import TestExpire from "../formFields/TestExpire";
import TestDuration from "../formFields/TestDuration";
import TestType from "../formFields/TestType";
import GradeSelect from "../formFields/GradeSelect";
import Categories from "../formFields/Categories";
import IndividualTest from "../formFields/IndividualTest";
import CustomDuration from "../formFields/CustomDuration";
import ItemsIds from "../formFields/ItemsIds";
import {isNotValidClassroomCheck} from "../utils/functions";

const TestConfigMultipleClassrooms = ({
                        type,
                        subjects,
                        grades,
                        createTestData,
                        setClassroomsHandler,
                        getSelectedClassrooms,
                        setTeacherHandler,
                        handleSelectChange,
                        handleInputChange,
                        setSubjectHandler,
                        setGradeHandler,
                        setSelectedCategoriesHandler,
                        handleTestStartDate,
                        setSelectedClassroomsStudentsHandler,
                        loading,
                        errors,
                        tags,
                        setSelectedStandardsHandler,
                    }: ICreateTestTrainingConfig) => {

    const hasUsers = createTestData.users.length > 0;
    const hasTag = Boolean(createTestData.tag.value);
    const hasExpire = Boolean(createTestData.expire);
    const hasCustomDuration = createTestData.custom_duration !== "";
    const hasSubject = Boolean(createTestData.subject.value);
    const hasGrade = Boolean(createTestData.grade.value);
    const hasCategories = createTestData.categories.length > 0;


    return (
        <>
            <ClassroomsSelect
                errors={errors}
                setClassroomsHandler={setClassroomsHandler}
                getSelectedClassrooms={getSelectedClassrooms}
                selectedClassrooms={createTestData.classrooms}
            />
            {hasUsers && (
                <CreateTestSelectedClassrooms
                    errors={errors}
                    loading={loading}
                    classrooms={createTestData.users}
                    selectedStudents={createTestData.users}
                    setSelectedStudentsHandler={setSelectedClassroomsStudentsHandler}
                    setTeacherHandler={setTeacherHandler}
                    handleTestStartDate={handleTestStartDate}
                />
            )}

            {!isNotValidClassroomCheck(createTestData.users) && (
               <>
                   <CreateTestConfiguration
                       testConfig={createTestData.test_config.value}
                       handleSelectChange={handleSelectChange}
                       errors={errors}
                   />

                   <TagSelect
                       errors={errors}
                       loading={loading}
                       tag={createTestData.tag.value}
                       tags={tags}
                       handleSelectChange={handleSelectChange}
                   />

                   {hasTag && type !== "customTest" && (
                       <>
                           <IndividualTest
                               testType={type}
                               errors={errors}
                               individualTest={createTestData.individual_test.value}
                               handleSelectChange={handleSelectChange}
                           />

                           <TestExpire
                               expire={createTestData.expire}
                               handleInputChange={handleInputChange}
                               errors={errors}
                           />
                       </>
                   )}

                   {hasTag && type === "customTest" && (
                       <TestExpire
                           expire={createTestData.expire}
                           handleInputChange={handleInputChange}
                           errors={errors}
                       />
                   )}

                   {(hasExpire && type === "customTest") && (
                       <CustomDuration
                           duration={createTestData.custom_duration}
                           handleInputChange={handleInputChange}
                           errors={errors}
                       />
                   )}

                   {(hasExpire && (type === "school") || (type === "customTest" && hasCustomDuration)) && (
                       <TestType
                           loading={loading}
                           errors={errors}
                           subject={createTestData.subject.value}
                           subjects={subjects}
                           setSubjectHandler={setSubjectHandler}
                       />
                   )}

                   {(hasSubject) && (
                       <GradeSelect
                           loading={loading}
                           errors={errors}
                           grade={createTestData.grade.value}
                           grades={grades}
                           setGradeHandler={setGradeHandler}
                       />
                   )}
                   {hasGrade && type !== "customTest" && (
                       <Categories
                           type={type}
                           loading={loading}
                           errors={errors}
                           categories={createTestData.categories}
                           grade={createTestData.grade.value}
                           setSelectedCategoriesHandler={setSelectedCategoriesHandler}
                           setSelectedStandardsHandler={setSelectedStandardsHandler ? setSelectedStandardsHandler : undefined}
                       />
                   )}
                   {hasCategories && type !== "customTest" && (
                       <TestDuration
                           errors={errors}
                           itemsNumber={createTestData.test_duration.value}
                           handleSelectChange={handleSelectChange}
                       />
                   )}

                   {hasCategories && type !== "customTest" && createTestData.individual_test.value === "0" && (
                       <ItemsIds
                           loading={loading}
                           errors={errors}
                           itemsIds={createTestData.items_ids}
                           handleInputChange={handleInputChange}
                       />
                   )}
               </>
            )}
        </>
    );
}

export default TestConfigMultipleClassrooms;